import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

// Empty/error state reusável. Substitui os divs genéricos espalhados
// ("Nenhum X encontrado", "Loja não encontrada") por um padrão único com
// ícone + título + descrição + ação opcional. A ação é o ponto crítico:
// empty sem CTA é beco; com CTA é onboarding disfarçado (lojista novo
// sem pedido vê "Compartilhe o link" em vez de tela em branco).
//
// Suporta ícone Lucide (padrão) ou imagem (PNG do projeto pra estados
// com mais personalidade — ex: empty-cart, default-product).

interface EmptyStateProps {
  icon?: LucideIcon;
  imageSrc?: string;
  imageAlt?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  icon: Icon,
  imageSrc,
  imageAlt = "",
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center text-center py-12 px-4", className)}>
      {imageSrc ? (
        <img src={imageSrc} alt={imageAlt} className="w-32 h-32 object-contain mb-4 opacity-90" />
      ) : Icon ? (
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-muted-foreground" aria-hidden />
        </div>
      ) : null}
      <h3 className="text-lg font-semibold text-foreground leading-tight">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mt-2 max-w-sm leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-5 flex flex-wrap items-center justify-center gap-2">{action}</div>}
    </div>
  );
}
